
import { Vue } from "vue-class-component";

export default class Wallet extends Vue {}
